export default __webpack_public_path__ + "static/media/0.8c268005.jpg";